<script setup>
import { onMounted, ref } from 'vue';
import { $api } from '@/services';
import Edit from '@/views/tuitionSetting/Edit.vue';
import { useStore } from 'vuex';

const store = useStore();
const sideOverShow = ref(false);
const content = ref('');
const src = ref('');
async function getTuitionNote() {
	try {
		const res = await $api.org.getTuitionNote();
		if (res.data.data !== null) {
			content.value = res.data.data.content;
			src.value = res.data.data.asset_url;
		}
	} catch (e) {
		store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}
function editSuccess() {
	sideOverShow.value = false;
	getTuitionNote();
}
onMounted(() => {
	getTuitionNote();
});
</script>
<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="close"
		></div>
		<Edit
			@close="sideOverShow = false"
			:content="content"
			:src="src"
			@success="editSuccess"
		/>
	</div>
	<div class="bg-white p-6 rounded-2xl shadow-sm text-gray-500">
		<div class="w-full flex items-center justify-between">
			<div class="text-lg font-semibold text-neutral-700">Cài đặt</div>
			<button
				class="
					button-p
					text-center
					bg-none
					shadow-none
					flex
					items-center
					justify-center
					btn--text
					w-fit
				"
				type="button"
				@click="sideOverShow = true"
			>
				<svg
					class="mr-2"
					fill="none"
					height="16"
					viewBox="0 0 16 16"
					width="16"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						clip-rule="evenodd"
						d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
						fill="currentColor"
						fill-rule="evenodd"
					/>
				</svg>
				Chỉnh sửa
			</button>
		</div>
		<div class="mt-4 flex items-stretch xl-down:flex-wrap">
			<div
				class="
					p-4
					border
					xl-down:rounded-tl-lg
					border-neutral-200
					w-full
					xl-down:w-1/2
					md-down:rounded-t md-down:rounded-b-none
				"
			>
				<div>Ghi chú</div>
				<div
					class="text-base font-normal text-neutral-600 mt-2"
					v-if="content"
					v-html="content.replace(/\n/g, '<br />')"
				></div>
				<div
					class="text-base italic font-light text-neutral-400 mt-2"
					v-else
				>
					Chưa có ghi chú
				</div>
			</div>

			<div
				class="
					p-4
					border
					rouder-r-lg
					xl-down:rounded-br-lg
					border-neutral-200
					w-full
					xl-down:w-1/2
					md-down:rounded-b md-down:rounded-t-none
				"
			>
				<div>Mã QR</div>
				<div
					class="text-base font-bold text-neutral-600 mt-2"
					v-if="src"
				>
					<img
						style="width: 200px; height: 200px"
						:src="src"
						alt=""
					/>
				</div>
				<div
					class="text-base italic font-light text-neutral-400 mt-2"
					v-else
				>
					Chưa có ảnh tải lên
				</div>
			</div>
		</div>
	</div>
</template>
